module.exports = __webpack_public_path__ + "img/casque.d9a580b0.jpg";